export default __webpack_public_path__ + "static/media/sport-active-m.990b4d8d.svg";